import addStartupScript from './events/addStartupScript';
import curationTagContentUI from '../templates/curation_tag_content.mustache';
import MicroModal from 'micromodal';
import Marked from 'marked';

// Fetch collection data from llt-reach endpoint
async function fetchCollectionData(curationTag) {
  if(curationTag === 'special-education-collection') curationTag = 'special-education-series';
  const data = window.collections[curationTag];

  if(data) {
    return Promise.resolve(data);
  } else {
    const response = await fetch(`/classes/collections/${curationTag}.json`);
    const json = await response.json()
      .then((data) => {
        window.collections[curationTag] = data;
        return data;
      })
      .catch(() => { return {}; });

    return json;
  }
}

// Render collection info inside of modal
function renderCollectionInfo(data) {
  const curationTagModal = document.querySelector('.curation-tag-content');

  curationTagModal.innerHTML = curationTagContentUI({title: data.name,
    description: Marked(data.details_description),
    collection_href: data.collection_href});
}

function showModal() {
  MicroModal.show('curation-tag-modal',
  {
    disableScroll: true,
    openClass: 'js-micromodal--open',
    onShow: () => {
      document.documentElement.classList.add('html--micromodal-open');
    },
    onClose: (modal, element, event) => {
      event.preventDefault();
      event.stopPropagation();
      document.documentElement.classList.remove('html--micromodal-open');
    }
  });
}

function showContent(data) {
  renderCollectionInfo(data);
  showModal();
}

export function setup() {
  window.collections = window.collections || {};

  // Listen for future dom elements (CourseListItem does not load right away)
  document.addEventListener('click', (e) => {
    const target = e.target;

    if (target.classList.contains('course-list-item-content__curation-tag')) {
      fetchCollectionData(target.getAttribute('data-id'))
        .then((data) => {
          if(!(Object.keys(data).length === 0)) { // If data is not empty, render modal
            showContent(data);
          }
        });
    }
  });
}

addStartupScript(setup);
